export const replaceEmptyStringsWithNull = <T>(data: T): T => {
  if (typeof data !== "object" || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => replaceEmptyStringsWithNull(item)) as T;
  }

  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      value === "" ? null : replaceEmptyStringsWithNull(value),
    ]),
  ) as T;
};
